import { Typography } from '@gyym/ui'

import { HeadingContainer } from './styles'

export interface HeadingProps {
  children: string
  centered?: boolean
  subheading?: string
  paragraph?: string
  pcOnly?: boolean
}

export const Heading = ({
  children,
  centered,
  subheading,
  paragraph,
  pcOnly = false,
}: HeadingProps) => (
  <HeadingContainer pcOnly={pcOnly} centered={centered}>
    <Typography
      variant="headline1"
      as="h1"
      textAlign={centered ? 'center' : undefined}
    >
      {children}
    </Typography>

    {subheading && (
      <Typography
        variant="subhead1"
        as="div"
        className="ml-auto pl-4 tablet:ml-0 tablet:pl-0"
      >
        {subheading}
      </Typography>
    )}

    {paragraph && (
      <div className="flex w-full">
        <Typography variant="body1" as="p" className="mt-4" color="gray.01">
          {paragraph}
        </Typography>
      </div>
    )}
  </HeadingContainer>
)
